import React from "react";
import { Modal as AntModal, Button, Calendar, Space as AntSpace } from "antd";
import styled from "styled-components";
import { useState } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-btn {
    min-width: 70px;
  }

  .ant-btn-dangerous {
    border-radius: 21px;
    border-color: gray !important;
    color: gray !important;

    :hover {
      border-color: gray !important;
      color: gray !important;
    }
  }

  @media screen and (max-width: 385px) {
    .ant-btn {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 350px) {
    .ant-picker-content thead tr {
      font-size: 13px;
    }
    .ant-picker-content tbody tr {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 310px) {
    .ant-picker-content thead tr {
      font-size: 12px;
    }
    .ant-picker-content tbody tr {
      font-size: 11px;
    }
  }
`;

const Space = styled(AntSpace)`
  @media screen and (max-width: 322px) {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

const dateFormat = "YYYY-MM-DD";

const CalendarModal = ({ open, date, onOk, onReset, handleClose }) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const onSelect = (date) => {
    setSelectedDate(date);
  };

  const footer = (
    <Space>
      <Button
        danger
        type="default"
        onClick={() => {
          handleClose();
          setSelectedDate(date ? dayjs(date, dateFormat) : dayjs());
        }}
      >
        {t("common.close")}
      </Button>
      <Button
        type="default"
        onClick={() => {
          selectedDate && onReset();
          setSelectedDate(dayjs());
          handleClose();
        }}
      >
        {t("common.reset")}
      </Button>
      <Button
        type="primary"
        onClick={() => {
          if (selectedDate) {
            onOk(selectedDate);
          }
        }}
      >
        {t("common.ok")}
      </Button>
    </Space>
  );

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      width={400}
      open={open}
      onCancel={handleClose}
      footer={footer}
      className="custom-calendar-modal"
    >
      <Calendar
        value={selectedDate}
        mode="month"
        fullscreen={false}
        onSelect={onSelect}
      />
    </Modal>
  );
};

export default CalendarModal;
